import type { Leasing } from '../../../../../types'
import { createColumnHelper } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import { formatDate } from '../../../../cars/components/V3/helpers/formatDate'
import { ReportColumnHeader } from '../ReportColumnHeader'

const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }

export default function leasingReportTableData() {
  const columnHelper = createColumnHelper<Leasing>()
  return [
    columnHelper.accessor('regNo', {
      id: 'regNo',
      header: () => <ReportColumnHeader title="Regnr" />,
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('vehicleID', {
      id: 'vehicleID',
      header: () => <ReportColumnHeader title="Kjøretøy-ID" />,
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('consolidatedAgreement', {
      id: 'consolidatedAgreement',
      header: () => <ReportColumnHeader title="Samlefakturakode" />,
      enableSorting: false,
      cell: ({ row }) => `${row?.original.consolidatedAgreementID} - ${row?.original.consolidatedAgreement}` || '',
    }),
    columnHelper.accessor('driverName', {
      id: 'driverName',
      header: () => <ReportColumnHeader title="Sjåfør" />,
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('maxKm', {
      id: 'maxKm',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Maks km" />,
      enableSorting: false,
      cell: (row) => formatNumber(row.getValue()),
    }),
    columnHelper.accessor('totalTerms', {
      id: 'totalTerms',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Terminer totalt" />,
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('termsNow', {
      id: 'termsNow',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Terminer løpt" />,
      enableSorting: false,
      cell: (row) => row.getValue() || '',
    }),
    columnHelper.accessor('remainingTerms', {
      id: 'remainingTerms',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Terminer gjenstår" />,
      cell: (row) => row.getValue() || '',
      enableSorting: false,
    }),
    columnHelper.accessor('startDate', {
      id: 'startDate',
      header: () => <ReportColumnHeader title="Startdato" />,
      cell: (row) => formatDate(row.getValue()) || '',
    }),
    columnHelper.accessor('returnDate', {
      id: 'returnDate',
      header: () => <ReportColumnHeader title="Returdato" />,
      cell: (row) => formatDate(row.getValue()) || '',
    }),
    columnHelper.accessor('termLeasing_incl_VAT', {
      id: 'termLeasing_incl_VAT',
      meta: {
        alignmentType: 'right',
      },
      header: () => <ReportColumnHeader title="Leasing leie mnd ink. mva" />,
      cell: (row) => formatNumber(row.getValue(), settings) || '',
      enableSorting: false,
    }),
    columnHelper.accessor('restLeasing_incl_VAT', {
      id: 'restLeasing_incl_VAT',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Sum leasingleie ink. mva',
      },
      enableSorting: false,
      header: () => <ReportColumnHeader title="Leasing forpliktelser ink. mva" />,
      cell: (row) => formatNumber(row.getValue(), settings) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('restLeasing_incl_VAT') as number) || 0), 0)
        return formatNumber(total, settings)
      },
    }),
    columnHelper.accessor('restLeasing_excl_VAT', {
      id: 'restLeasing_excl_VAT',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Sum leasing forpliktelser eks. mva',
      },
      enableSorting: false,
      header: () => <ReportColumnHeader title="Leasing forpliktelser eks. mva" />,
      cell: (row) => formatNumber(row.getValue(), settings) || '',
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + ((row.getValue('restLeasing_excl_VAT') as number) || 0), 0)
        return formatNumber(total, settings)
      },
    }),
  ]
}
